import {createSelector} from 'reselect';
import getAddresses from '../DeliveryAddressSelectors/getAddresses';
import {getPlaceOrderDeliveryAddress} from './PlaceOrderPropertiesSelectors';

export default createSelector(
  [getPlaceOrderDeliveryAddress, getAddresses],
  (placeOrderDeliveryAddress, addresses) => {
    if (placeOrderDeliveryAddress?.addressId) {
      return addresses?.[placeOrderDeliveryAddress?.addressId];
    }
    
    return placeOrderDeliveryAddress;
  },
);
